export const getUnreadMessages = (bookInLedger) => {
  if (!bookInLedger || !bookInLedger?.chat) return null

  const chatId = bookInLedger.chat.id
  const messages = JSON.parse(bookInLedger.chat.messages) || []

  const lastReadMap = JSON.parse(localStorage.getItem("lastReadMap") || "{}")

  const lastRead = lastReadMap[chatId] || 0

  return messages.filter((m) => !lastRead || m.Timestamp > lastRead).length
}

export const markMessagesAsRead = (chatMessages, chatId) => {
  const lastReadMap = JSON.parse(localStorage.getItem("lastReadMap") || "{}")

  const latestTimestamp = chatMessages[chatMessages.length - 1]?.Timestamp || Date.now()

  lastReadMap[chatId] = latestTimestamp

  localStorage.setItem("lastReadMap", JSON.stringify(lastReadMap))
}
